module.exports = __webpack_public_path__ + "img/makeone.495c304d.png";